module.exports = __webpack_public_path__ + "img/manda_010.4e7f0884.png";